"use client";

import { useQuery } from "@tanstack/react-query";
import { reportStats } from "../api/reportStats";
import { useAuth } from "@/state/globalStore";
import { profileKeys } from "./keys";

export default function useReportStatsQuery() {
  const { accessToken } = useAuth();

  const reportStatsQuery = useQuery({
    queryKey: profileKeys.reportStats(),
    queryFn: () => reportStats(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 1000 * 60 * 5,
  });

  return {
    stats: reportStatsQuery.data ?? null,
    isLoading: reportStatsQuery.isLoading,
    error:
      reportStatsQuery.error instanceof Error
        ? reportStatsQuery.error.message
        : reportStatsQuery.error
          ? "Unable to load stats"
          : null,
  };
}
